module.exports = __webpack_public_path__ + "img/1.9bcd5671.png";